import { observer } from 'mobx-react';
import { ReactElement } from 'react';
import ChangesTable from './components/Changes/Changes';
import CustomModalComponent from 'src/view/components/Controls/Modal/Modal';
import ModalBackground from 'src/view/components/Controls/Modal/ModalBackground/ModalBackground';
import { modalStore } from '~/mobx/modalStore';
import './style.scss';
import ModalHeader from '~/view/components/Controls/Modal/ModalHeader/ModalHeader';
import { localeStore } from '~/mobx/localesStore';

const closeHandler = () => {
  modalStore.closeBranchesLogModal();
};

const BranchesLogModal = (): ReactElement | null => {
  if (modalStore.branchesLogModal === null) {
    return null;
  }

  const title = localeStore.t('changes_to', { branch: modalStore.branchesLogModal.branch ?? '-' });

  return (
    <CustomModalComponent isOpen className="branches-log-modal" onRequestClose={closeHandler} withCloseIcon>
      <ModalBackground>
        <ModalHeader title={title} />
        <ChangesTable log={modalStore.branchesLogModal} />
      </ModalBackground>
    </CustomModalComponent>
  );
};

export default observer(BranchesLogModal);
